import React from 'react'
import { NavLink } from 'react-router-dom'

const Common = (props) => {
    
  return (
    <>
      <section className='d-flex align-items-center' id='header'>
        <div className='container-fluid'>
          <div className='row'> 
            <div className='col-10 mx-auto'>
              <div className="row">
              <div className="col-lg-6 col-md-12 col-sm-12  pt-4 pt-lg-0 order-2 order-lg-1 d-flex justify-content-center flex-column">
                <h1>{props.name} <strong className='brand-name'>codex.</strong>
                </h1>
                <h2 className='my-3'>
                  We are the Team of Talented Developers.
                </h2>
                <h3>We make <strong>Website</strong> for you. That will help your Business to Grow.</h3>
                <div className="mt-3">
                  <NavLink to={props.visit} className='btn-get-started'>{props.btname}</NavLink>
                </div>
              </div>

              <div className="col-lg-6 order-1 col-lg-2 header-img">
                <img src={props.imgsrc} className='img-fluid animated' alt="homeimg" />
              </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Common
